export const news = {
  newsFeedCreateInputPlaceholder: 'Schreibe einen Beitrag...',
  newsFeedSearchInputPlaceholder: 'Suchen',
  newsFeedPostOwnerCurtainEditTitle: 'Beitrag bearbeiten',
  newsFeedPostOwnerCurtainDeleteTitle: 'Beitrag löschen',
  newsFeedEditedPostSavedAlertText: 'Beitrag gespeichert!',
  newsFeedEditedPostDeletedAlertText: 'Beitrag gelöscht!',
  newsFeedShareCurtainOptionTitle: 'Link kopieren',
  newsFeedPostLinkCopiedAlertText: 'Link kopiert!',
  newsFeedOthersPostCurtainOptionCopyTitle: 'Link kopieren',
  newsFeedOthersPosLinkCopiedAlertText: 'Link kopiert!',
  newsFeedOthersPostCurtainOptionFlagTitle: 'Melden',
  newsFeedOtherPostOwnersCurtainDeleteTitle: 'Beitrag löschen',
  newsFeedPostDeletePopupTitle: 'Löschen',
  newsFeedPostDeletePopupText: 'Diesen Beitrag löschen?',
  newsFeedPostDeletePopupCancelButtonTitle: 'Abbrechen',
  newsFeedPostDeletePopupConfirmButtonTitle: 'Bestätigen',
  newsFeedPostDeeletedAlertText: 'Beitrag gelöscht!',
  newsPostDetailsHeaderTitle: 'Beitrag',
  postFeedPostLikesText: 'Gefällt mir',
  postFeedPostCommentsText: 'Kommentare',
  postFeedPostNoLikesText: 'Es gibt noch keine „Gefällt mir“-Angaben',
  postFeedPostLeaveFirstLikeText: 'Du kannst der Erste sein, der „Gefällt mir“ angibt',
  newsFeedPostDetailsNoCommentsText: 'Es gibt noch keine Kommentare',
  newsFeedPostDetailsFirstCommentText: 'Du kannst der Erste sein, der einen Kommentar hinterlässt',
  newsFeedPostDetailsShareOptionTitle: 'Link kopieren',
  newsFeedPostDetailsSharePostCopiedAlertText: 'Link kopiert!',
  newsFeedPostDetailsUsersCurtainCopyOptionTitle: 'Link kopieren',
  newsFeedPostDetailsCopiedAlertText: 'Link kopiert!',
  newsFeedPostDetailsUsersCurtainFlagOptionTitle: 'Melden',
  newsPostDetailsFlagCurtainOptionSpamTitle: 'Melden',
  newsPostDetailsReportedCurtainText: 'Inhalt gemeldet',
  newsPostDetailsCommentOwnerCurtainEditOptionTitle: 'Kommentar bearbeiten',
  newsPostDetailsCommentOwnerCurtainDeleteOptionTitle: 'Kommentar löschen',
  newsPostDetailsEditedCommentSavedAlertText: 'Kommentar gespeichert!',
  postDetailsOtherCommentAppOwnerCurtainOptionTitle: 'Kommentar löschen',
  postDetailsOtherUsersCommentDeletadAlertText: 'Kommentar gelöscht!',
  postDetailsDeleteCommentPopupTitle: 'Löschen',
  postDetailsDeleteCommentPopupText: 'Diesen Kommentar löschen?',
  postDetailsDeleteCommentPopupCancelButtonTitle: 'Abbrechen',
  postDetailsDeleteCommentPopupConfirmlButtonTitle: 'Bestätigen',
  postDetailsCommDeletedAlertText: 'Kommentar gelöscht!',
  postDetailsCommentUserCurtainOptionTitle: 'Kommentar melden',
  newsCreatePostCurtainTitle: 'Neuer Beitrag',
  newsCreatePostCurtainBodyPlaceholder: 'Schreibe deinen Text hier...',
  newsCreatePostPublishButtonTitle: 'Veröffentlichen',
  newsCreatePostUploadSlallerImageAlertText: 'Du kannst nicht mehr als {size} MB gleichzeitig hochladen',
  newsPostSavedAlertText: 'Beitrag gespeichert!',
  newsCreatePostAddLocationCurtainTitle: 'Ort',
  newsCreatePostAddLocationCurtainInputPlaceholder: 'Ortsname',
  newsCreatePostEditLocationCurtainText: 'Ort bearbeiten',
  newsDeleteLocation: 'Ort löschen',
  newsDiscardPostPopupTitle: 'Entwurf',
  newsDiscardPostPopupText: 'Diesen Entwurf verwerfen?',
  newsDiscardPostPopupCancelButtonTitle: 'Abbrechen',
  newsDiscardPostPopupCofirmButtonTitle: 'Bestätigen',
  newsNewPostCreatePollTitle: 'Umfrage erstellen',
  newsNewPostCreatePollTitleInputPlaceholder: 'Titel',
  newsNewPostCreatePollOptionInputPlaceholder: 'Option',
  newsNewPostCreatePollAddButtonTitle: 'Option hinzufügen',
  newsNewPostCreatePollCreateButtonTitle: 'Erstellen',
  newsCreatePostPollTitleBlankAlertText: 'Der Titel darf nicht leer sein!',
  newsCreatePostPollOptionBlankAlertText: 'Die Option darf nicht leer sein!',
  newsCreatePostPollLongTitleAlertText: 'Der Titel darf maximal {length} Zeichen enthalten',
  newsCreatePostPollLongOptionAlertText: 'Die Option darf maximal {length} Zeichen enthalten',
  newsCreatePostPollEditOptionTitle: 'Umfrage bearbeiten',
  newsCreatePostPollRemoveOptionTitle: 'Umfrage entfernen',
  newsPostPollInfoVotesText: 'Abstimmungen',
  newsPostPollInfoEditVoteText: 'Stimme bearbeiten',
  newsPostPollFinishPollText: 'Umfrage beenden',
  newsPostPollFinishedPollText: 'Abgeschlossen',
  newsPostPollInProgresslText: 'In Bearbeitung',
  newsFinishPollCurtainTitle: 'Umfrage beenden',
  newsFinishPollCurtainText: 'Benutzer können nach Abschluss der Umfrage nicht mehr abstimmen.',
  newsFinishPollCurtainCancelButtonTitle: 'Abbrechen',
  newsFinishPollCurtainConfirmlButtonTitle: 'Bestätigen',
  newsPollInfoPollVotesCurtainTitle: 'Umfrageergebnisse',
  newsEditPostCurtainTitle: 'Beitrag bearbeiten',
  newsEditPostCurtainNoTextBodyPlaceholder: 'Schreibe deinen Text hier...',
  newsEditPostCurtainSaveButtonTitle: 'Speichern',
  newsEditPostSavedAlertText: 'Beitrag gespeichert!',
  newsError: 'Ein Fehler ist aufgetreten!',
  newsAt: 'am',
  newsSeeMore: 'Mehr anzeigen...',
  newsMaxAttachments: 'Sie haben die maximale Anzahl von Anhängen überschritten. Die maximale Anzahl von Anhängen beträgt {length}',
  newsReply: 'Antworten',
  newsPin: 'Beitrag anpinnen',
  newsUnpin: 'Beitrag lospinnen'
}
